import { render, staticRenderFns } from "./scroll-box.vue?vue&type=template&id=cae5cb70&scoped=true&"
import script from "./scroll-box.vue?vue&type=script&lang=js&"
export * from "./scroll-box.vue?vue&type=script&lang=js&"
import style0 from "./scroll-box.vue?vue&type=style&index=0&id=cae5cb70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cae5cb70",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/01-qym-hop-newmall-frontend-k8s@3/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cae5cb70')) {
      api.createRecord('cae5cb70', component.options)
    } else {
      api.reload('cae5cb70', component.options)
    }
    module.hot.accept("./scroll-box.vue?vue&type=template&id=cae5cb70&scoped=true&", function () {
      api.rerender('cae5cb70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/chatLog/lib/scroll-box.vue"
export default component.exports